import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import Layout from '../../components/Layout';
import FAQ from '../../components/faq';
import FAQLanguageTitle from '../../components/FAQLanguageTitle';
import { SIKKA_FAQS } from '@/data/faq';
import classes from './styles.module.scss';
import { PACKAGE } from '../../constants';
import { StorageService } from '../../service/Storage';

const SUPPORTED_LANGS = ['en', 'hi', 'mr', 'gu', 'id'];

export default function FaqPage() {
  const router = useRouter();

  // Map 'in' query param to 'id' internal code
  const getLangFromQuery = () => {
    const queryLang = router.query.lang;
    if (!queryLang) return 'en';
    
    // Map 'in' to 'id' for Indonesian
    const mappedLang = queryLang === 'in' ? 'id' : queryLang;
    
    // Validate against supported languages
    return SUPPORTED_LANGS.includes(mappedLang) ? mappedLang : 'en';
  };

  const [currentLang, setCurrentLang] = useState(getLangFromQuery());

  useEffect(() => {
    setCurrentLang(getLangFromQuery());
  }, [router.query.lang]);

  useEffect(() => {
    StorageService.setXPN(PACKAGE);
  }, []);

  return (
    <Layout>
      <div className={classes.FaqPage}>
        <FAQLanguageTitle lang={currentLang} />
        <FAQ list={SIKKA_FAQS} initialLang={currentLang} onLangChange={setCurrentLang} />
      </div>
    </Layout>
  );
}
